<template>
    <tr>
        <td>
            <input type="text" class="form-control" v-model="color.paint_code" placeholder="Tulis kode warna">
        </td>
        <td>
            <input type="text" class="form-control" v-model="color.name" :disabled="disableName" placeholder="Tulis nama warna">
        </td>
        <td>
            <input type="text" class="form-control" v-model="color.used_weight" placeholder="Ketik berat(gram) terpakai">
        </td>
        <td class="text-center">
            <button type="button" class="btn btn-outline-danger" @click="$emit('newComposition')" :disabled="!buttonsShow">
                <i class="fas fa-times"></i>
            </button>
        </td>
    </tr>
</template>

<script>
export default {
    props : ['color' , 'buttonsShow' , 'paintList'],
    watch : {
        'color.paint_code' : function () {
            let findPaint = this.paintList.find( x => x.paint_code == this.color.paint_code)

            if(findPaint) {
                this.disableName = true

                this.color.name = findPaint.paint_name
            }
            else {
                this.disableName = false
                this.color.name == ''
            }
        }
    },
    data () {
        return {
            disableName : false
        }
    }
}
</script>